import React from 'react'
import { observer } from 'mobx-react'
import useIndex from '../hooks/use-index'
import useCollection from './hooks/use-collection'
import ModelContext from '../contexts/ModelContext'

function CollectionEntryToModel (props) {
  const collection = useCollection()
  const index = useIndex()

  if (!collection || !collection[index]) {
    return null
  }

  return (
    <ModelContext.Provider value={collection[index]}>
      {props.children}
    </ModelContext.Provider>
  )
}

export default observer(CollectionEntryToModel)
